import { DatePickerCustom, InputLista, InputNumber, Loading, Modal, TableCustom } from "../../common"
import { getDateToString, getFormatNumber, getNumeroRecibo_ObjectToString } from "../../../utils/convert"
import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { useEntidad, useForm, useLista } from "../../hooks"
import { ServerRequest } from "../../../utils/apiweb"
import { APIS } from "../../../config/apis"


const LoteField = ({ value, navigateTo, onNavigate }) => {
    const handleCopy = () => {
        if (value) {
            navigator.clipboard.writeText(String(value))
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, 'Copiado al portapapeles')
        }
    }

    const handleNavigate = () => {
        if (value && navigateTo && onNavigate) {
            onNavigate(navigateTo, value)
        }
    }

    return (
        <div className="wrapper">
            <input
                type="text"
                className="form-control text-truncate"
                style={{ paddingRight: value ? (navigateTo ? '52px' : '28px') : undefined }}
                value={value || '-'}
                disabled={true}
                title={value ? String(value) : ''}
            />
            {value && (
                <>
                    <span
                        className="material-symbols-outlined icon-cruz"
                        style={{ right: navigateTo ? '26px' : '2px', fontSize: '18px' }}
                        onClick={handleCopy}
                        title="Copiar"
                    >content_copy</span>
                    {navigateTo && (
                        <span
                            className="material-symbols-outlined icon-cruz"
                            style={{ right: '2px', fontSize: '18px' }}
                            onClick={handleNavigate}
                            title="Buscar lote"
                        >open_in_new</span>
                    )}
                </>
            )}
        </div>
    )
}


const ReciboPublicacionModal = ({ id, codigoDelegacion, numeroRecibo, onCancel, onLoteNavigate }) => {

    const navigate = useNavigate()
    const { pathname } = useLocation()

    const [apertura, setApertura] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (id??0 > 0) {
            FindReciboPublicacionById();
        }
        else if ((codigoDelegacion??"") != "" && (numeroRecibo??0) > 0) {
            FindReciboPublicacionByNumero();
        }
    }, []);

    const [getLista, ] = useLista({
        listas: ['TipoTributo'],
        onLoaded: (listas, isSuccess, error) => {
          if (!isSuccess) {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
          }
        },
        memo: {
          key: 'TipoTributo',
          timeout: 0
        }
    });

    const [getEntidad, ] = useEntidad({
        entidades: ['TipoMovimiento'],
        onLoaded: (_, isSuccess, error) => {
          if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error)
        },
        memo: null
    });

    const [formValues, formHandle, , formSet] = useForm({
        codigoTipoTributo: '',
        numeroCuenta: '',
        codigoDelegacion: '',
        numeroRecibo: 0,
        periodo: '',
        cuota: 0,
        importeVencimiento1: 0,
        importeVencimiento2: 0,
        fechaVencimiento1: null,
        fechaVencimiento2: null,
        numeroLoteReciboPublicacion: '',
        numeroLoteRecaudacion: '',
        numeroLotePagoRendicion: '',
        numeroLoteRegistroContable: ''
    });

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
            .then((error) => {
                const message = error.message;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setLoading(false);
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setLoading(false);
            });
    }

    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setLoading(false);
    }

    const callbackSuccess = (response) => {
        response.json()
            .then((reciboPublicacion) => {
                setLoading(false);
                setApertura(reciboPublicacion.recibosApertura);
                formSet({
                    codigoTipoTributo: reciboPublicacion.codigoTipoTributo,
                    numeroCuenta: reciboPublicacion.numeroCuenta,
                    codigoDelegacion: reciboPublicacion.codigoDelegacion,
                    numeroRecibo: reciboPublicacion.numeroRecibo,
                    periodo: reciboPublicacion.periodo,
                    cuota: reciboPublicacion.cuota,
                    importeVencimiento1: reciboPublicacion.importeVencimiento1,
                    importeVencimiento2: reciboPublicacion.importeVencimiento2,
                    fechaVencimiento1: new Date(reciboPublicacion.fechaVencimiento1),
                    fechaVencimiento2: new Date(reciboPublicacion.fechaVencimiento2),
                    numeroLoteReciboPublicacion: reciboPublicacion.numeroLoteReciboPublicacion ?? '',
                    numeroLoteRecaudacion: reciboPublicacion.numeroLoteRecaudacion ?? '',
                    numeroLotePagoRendicion: reciboPublicacion.numeroLotePagoRendicion ?? '',
                    numeroLoteRegistroContable: reciboPublicacion.numeroLoteRegistroContable ?? ''
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setLoading(false);
            });
    };

    //functions
    function FindReciboPublicacionById() {

        setLoading(true);

        const paramsUrl = `/recibo/apertura/${id}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.RECIBO_PUBLICACION_LOTE,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function FindReciboPublicacionByNumero() {

        setLoading(true);

        const paramsUrl = `/recibo/numero/apertura/${codigoDelegacion}/${numeroRecibo}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.RECIBO_PUBLICACION_LOTE,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    const getNombreTipoTributo = (codigoTipoTributo) => {
        const listaTipoTributo = getLista('TipoTributo');
        const tipoTributo = listaTipoTributo.find(item => item.codigo === codigoTipoTributo);
        return tipoTributo ? tipoTributo.nombre : "";
    }

    const getNombreTipoMovimiento = (codigoTipoMovimiento) => {
        const listaTipoMovimiento = getEntidad('TipoMovimiento');
        const tipoMovimiento = listaTipoMovimiento.find(item => item.codigo === codigoTipoMovimiento);
        return tipoMovimiento ? tipoMovimiento.nombre : "";
    }

    const handleLoteNavigate = (path, numeroLote) => {
        onCancel()
        navigate(path, { state: { numeroLote: String(numeroLote), ...onLoteNavigate?.() } })
    }

    return (
        <Modal
            onEscape={onCancel}
            size="xl"
            title={`VEP ${getNumeroRecibo_ObjectToString(formValues)}`}
            body={(
                <>
                    <Loading visible={loading}></Loading>

                    <div className="row">
                        <div className="mb-3 col-12 col-lg-3">
                            <label htmlFor="codigoTipoTributo" className="form-label">Tipo tributo</label>
                            <input
                                name="codigoTipoTributo"
                                type="text"
                                placeholder=""
                                className="form-control"
                                value={getNombreTipoTributo(formValues.codigoTipoTributo)}
                                disabled={true}
                            />
                        </div>

                        <div className="mb-3 col-12 col-lg-3">
                            <label htmlFor="numeroCuenta" className="form-label">Número de cuenta</label>
                            <input
                                name="numeroCuenta"
                                type="text"
                                placeholder=""
                                className="form-control"
                                value={formValues.numeroCuenta}
                                disabled={true}
                            />
                        </div>

                        <div className="mb-3 col-12 col-lg-3">
                            <label htmlFor="periodo" className="form-label">Periodo</label>
                            <input
                                name="periodo"
                                type="text"
                                placeholder=""
                                className="form-control"
                                value={formValues.periodo}
                                disabled={true}
                            />
                        </div>

                        <div className="mb-3 col-12 col-lg-3">
                            <label htmlFor="cuota" className="form-label">Cuota</label>
                            <input
                                name="cuota"
                                type="number"
                                className="form-control"
                                value={formValues.cuota}
                                disabled={true}
                            />
                        </div>

                        <div className="mb-3 col-12 col-lg-3">
                            <label htmlFor="importeVencimiento1" className="form-label">Importe 1° Vto.</label>
                            <InputNumber
                                name="importeVencimiento1"
                                className="form-control"
                                precision={2}
                                value={formValues.importeVencimiento1}
                                disabled={true}
                            />
                        </div>

                         <div className="mb-3 col-12 col-lg-3">
                            <label htmlFor="importeVencimiento2" className="form-label">Importe 2° Vto.</label>
                            <InputNumber
                                name="importeVencimiento2"
                                className="form-control"
                                precision={2}
                                value={formValues.importeVencimiento2}
                                disabled={true}
                            />
                        </div>

                        <div className="mb-3 col-12 col-lg-3">
                            <label htmlFor="fechaVencimiento1" className="form-label">Fecha 1° Vto.</label>
                            <DatePickerCustom
                                name="fechaVencimiento1"
                                placeholder=""
                                className="form-control"
                                value={ formValues.fechaVencimiento1 }
                                disabled={true}
                            />
                        </div>


                        <div className="mb-3 col-12 col-lg-3">
                            <label htmlFor="fechaVencimiento2" className="form-label">Fecha 2° Vto.</label>
                            <DatePickerCustom
                                name="fechaVencimiento2"
                                placeholder=""
                                className="form-control"
                                value={ formValues.fechaVencimiento2 }
                                disabled={true}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="mb-3 col-12 col-lg-3">
                            <label className="form-label">N° lote publicación</label>
                            <LoteField
                                value={formValues.numeroLoteReciboPublicacion}
                                navigateTo={pathname !== "/publicacion/historial" ? "/publicacion/historial" : undefined}
                                onNavigate={handleLoteNavigate}
                            />
                        </div>
                        <div className="mb-3 col-12 col-lg-3">
                            <label className="form-label">N° lote recaudación</label>
                            <LoteField
                                value={formValues.numeroLoteRecaudacion}
                                navigateTo={pathname !== "/recaudacion/historial" ? "/recaudacion/historial" : undefined}
                                onNavigate={handleLoteNavigate}
                            />
                        </div>
                        <div className="mb-3 col-12 col-lg-3">
                            <label className="form-label">N° lote rendición IIPP</label>
                            <LoteField
                                value={formValues.numeroLotePagoRendicion}
                                navigateTo={pathname !== "/rendicion/historial/ingresos-publicos" ? "/rendicion/historial/ingresos-publicos" : undefined}
                                onNavigate={handleLoteNavigate}
                            />
                        </div>
                        <div className="mb-3 col-12 col-lg-3">
                            <label className="form-label">N° lote rendición Contaduría</label>
                            <LoteField
                                value={formValues.numeroLoteRegistroContable}
                                navigateTo={pathname !== "/rendicion/historial/contaduria" ? "/rendicion/historial/contaduria" : undefined}
                                onNavigate={handleLoteNavigate}
                            />
                        </div>
                    </div>

                    <label className="form-label m-top-10">Apertura de tasas</label>
                    <TableCustom
                        className={'TableCustomBase m-top-5'}
                        data={apertura}
                        columns={[
                            { Header: 'Tasa', accessor: 'codigoTasa', width: '11%' },
                            { Header: 'Sub tasa', accessor: 'codigoSubTasa', width: '14%' },
                            // Después se va a agregar
                            // { Header: 'Codigo Rubro', accessor: 'codigoRubro', width: '12%' },
                            { Header: 'Tipo movimiento', Cell: (data) => getNombreTipoMovimiento(data.value), accessor: 'codigoTipoMovimiento', width: '14%', alignCell: 'right' },
                            { Header: 'Periodo', accessor: 'periodo', width: '8%' },
                            { Header: 'Cuota', accessor: 'cuota', width: '7%' },
                            { Header: 'Importe', Cell: (data) => getFormatNumber(data.value, 2), accessor: 'importeImputacionContable', width: '8%', alignCell: 'right' },
                            // Después se va a agregar
                            // { Header: 'Certificado', accessor: 'numeroCertificadoApremio', width: '10%' },
                            // Después se va a agregar
                            // { Header: 'Vencimiento', accessor: 'vencimiento', width: '11%' },
                            { Header: 'Fecha Vto.', Cell: (data) => getDateToString(data.value, false), accessor: 'fechaVencimiento', width: '13%' },
                        ]}
                    />
                </>
            )}
            footer={(
                <div className="width-100p disp-b">
                    <button className="btn back-button m-left-5" data-dismiss="modal" onClick={onCancel}>Volver</button>
                </div>
            )}
        />
    )
}

export default ReciboPublicacionModal
